module.exports = __webpack_public_path__ + "img/com11.d307d424.png";